const FilterButtons = {
	init() {
		document.querySelectorAll('.posts-filter').forEach((container) => {
			const handler = container.dataset.hierarchical
				? FilterButtons.onClickHierarchical
				: FilterButtons.onClickFlat;
			container.addEventListener('click', handler);
		});
	},

	// ─────────────────────────────────────────
	// MODE FLAT (comportement sans enfants)
	// ─────────────────────────────────────────

	onClickFlat(event) {
		const button = event.target.closest('.button-filter');
		if (!button) return;

		const group = button.closest('.posts-filter');
		const allButtons = group.querySelectorAll('.button-filter');

		button.dataset.filterType === 'all'
			? FilterButtons.activateOnly(button, allButtons)
			: FilterButtons.toggleFilter(button, allButtons);
	},

	// ─────────────────────────────────────────
	// MODE HIÉRARCHIQUE
	// ─────────────────────────────────────────

	onClickHierarchical(event) {
		const button = event.target.closest('.button-filter');
		if (!button) return;

		const container = button.closest('.posts-filter');

		if (button.closest('.posts-filter__parents')) {
			FilterButtons.handleParentClick(button, container);
		} else if (button.closest('.posts-filter__children-group')) {
			FilterButtons.handleChildClick(button);
		}
	},

	handleParentClick(button, container) {
		const childrenRow = container.querySelector('.posts-filter__children');
		const allParents = container.querySelectorAll('.posts-filter__parents .button-filter');
		const allGroups = container.querySelectorAll('.posts-filter__children-group');
		const wasActive = button.classList.contains('is-active');

		// Reset complet des parents et des groupes enfants
		allParents.forEach((b) => b.classList.remove('is-active'));
		allGroups.forEach((g) => g.classList.add('hidden'));
		childrenRow.classList.add('hidden');

		// Bouton "all" parent → reset total, on s'arrête là
		if (button.dataset.filterType === 'all') {
			button.classList.add('is-active');
			return;
		}

		// Toggle : si le bouton était déjà actif, on le laisse désactivé
		if (wasActive) return;

		// Activation du parent cliqué
		button.classList.add('is-active');

		// Affichage du groupe enfants correspondant
		const filterId = button.dataset.filterId;
		if (filterId !== undefined) {
			const group = container.querySelector(
				`.posts-filter__children-group[data-parent-id="${filterId}"]`
			);
			if (group) {
				childrenRow.classList.remove('hidden');
				group.classList.remove('hidden');
				// Réinitialise la sélection enfants à chaque ouverture
				group
					.querySelectorAll('.button-filter')
					.forEach((b) => b.classList.remove('is-active'));
			}
		}
	},

	handleChildClick(button) {
		const group = button.closest('.posts-filter__children-group');
		const allChildren = group.querySelectorAll('.button-filter');

		button.dataset.filterType === 'all'
			? FilterButtons.activateOnly(button, allChildren)
			: FilterButtons.toggleFilter(button, allChildren);
	},

	// ─────────────────────────────────────────
	// HELPERS COMMUNS
	// ─────────────────────────────────────────

	// Active uniquement ce bouton, désactive tous les autres du scope
	activateOnly(button, buttons) {
		buttons.forEach((b) => b.classList.remove('is-active'));
		button.classList.add('is-active');
	},

	// Toggle ce bouton, désactive le bouton "all" du scope si présent
	toggleFilter(button, buttons) {
		buttons.forEach((b) => {
			if (b.dataset.filterType === 'all') b.classList.remove('is-active');
		});
		button.classList.toggle('is-active');
	},
};

export default FilterButtons;
